import { forwardRef } from "react";

import { Button, type ButtonProps } from "./button";

export const SecondaryButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      children,
      onClick,
      isDisabled,
      size,
      loading,
      ...props
    }: ButtonProps,
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        className={className}
        variant="secondary"
        isDisabled={isDisabled}
        onClick={onClick}
        size={size}
        loading={loading}
        {...props}
      >
        {children}
      </Button>
    );
  },
);
